import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable } from "rxjs";

/**
 * This interceptor used to route Hookdeck API requests through the local development proxy.
 * Since we now use a cloud function to handle the proxying, this functionality is no longer needed.
 * We're keeping the interceptor class as a placeholder in case we need to add more HTTP interceptor
 * functionality in the future.
 */
@Injectable()
export class ApiProxyInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request);
  }
}
